import { Severity } from 'Data/ViewModels/Core/types';
import classNames from 'classnames';
import React from 'react';
import coalesce from '../../../Lib/coalesce';
import { withInjectedProps } from '../InjectedPropsContext';

export type ITextInputProps = Pick<
  React.DetailedHTMLProps<React.InputHTMLAttributes<HTMLInputElement>, HTMLInputElement>,
  | 'autoFocus'
  | 'defaultValue'
  | 'disabled'
  | 'readOnly'
  | 'id'
  | 'maxLength'
  | 'name'
  | 'onChange'
  | 'onKeyDown'
  | 'placeholder'
  | 'onBlur'
> & {
  focusRef?: React.Ref<HTMLInputElement>;
  severity?: Severity;
  value?: any;
};

const TextInputBase: React.FC<ITextInputProps> = ({
  autoFocus,
  defaultValue,
  disabled,
  readOnly,
  id,
  focusRef,
  maxLength,
  name,
  onChange,
  onKeyDown,
  placeholder,
  severity,
  value,
  onBlur,
}) => {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    (event as any).data = { name, value: event.target.value, submitValues: false };
    onChange?.(event);
  };

  const handleBlur = (event: React.FocusEvent<HTMLInputElement>) => {
    if (onChange) {
      (event as any).data = { name, value: event.target.value.trim(), submitValues: true };
      onChange(event as any);
    }
    onBlur?.(event);
  };

  const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter' && !event.defaultPrevented) {
      (event as any).data = { name, value: (event.target as HTMLInputElement).value.trim(), submitValues: true };
      onChange?.(event as any);
    }
    onKeyDown?.(event);
  };
  const cx = classNames('TextInput', { [`Input-${severity}`]: !!severity });

  return (
    <input
      autoFocus={autoFocus}
      className={cx}
      defaultValue={defaultValue === undefined ? defaultValue : coalesce(defaultValue, '')}
      disabled={disabled}
      readOnly={readOnly}
      id={id}
      maxLength={maxLength}
      name={name}
      onBlur={handleBlur}
      onChange={handleChange}
      onKeyDown={handleKeyDown}
      placeholder={placeholder ?? `Enter text`}
      ref={focusRef}
      type={'text'}
      value={value === undefined ? value : coalesce(value, '')}
    />
  );
};

const TextInput = withInjectedProps(TextInputBase);

export { TextInput, TextInputBase };
export default TextInput;
